// extracted by mini-css-extract-plugin
export default {"BurgerComponents":"burger-components_BurgerComponents__4hEH+","BurgerCenter":"burger-components_BurgerCenter__Hjq4q"};